// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1vF3U","emails":"CreateEditClinics_emails__1CQol","emailTagLabel":"CreateEditClinics_emailTagLabel__1RaW4"};